<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder mb-0">{{ $t('association.Association_info') }}</h5>
    <p class="mb-0 text-sm">{{ $t('association.Mandatory_informations') }} *</p>
    <div class="multisteps-form__content">
      <div class="row mt-4">
        <div class="col-8">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('association.Name') }} *</label>
                <input v-model="localFormData.name" type="text" class="form-control form-control-default" :placeholder="$t('association.Name')">
                <span v-if="v$.name.$error" class="text-sm text-danger">
                  {{ v$.name.$errors[0].$message }}
                </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('association.Abbreviation') }} *</label>
                <input v-model="localFormData.abbreviation" type="text" class="form-control form-control-default" :placeholder="$t('association.Abbreviation')">
                <span v-if="v$.abbreviation.$error" class="text-sm text-danger">
                  {{ v$.abbreviation.$errors[0].$message }}
                </span>
            </div>
          </div>        
      </div>
      <div class="row mt-3">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('association.Chamber_of_commerce_no') }}</label>
              <input v-model="localFormData.chamberOfCommerceNo" type="text" class="form-control form-control-default" :placeholder="$t('association.Chamber_of_commerce_no')">
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('association.RVORelationnumber') }}</label>
              <input v-model="localFormData.rvoRelationnumber" type="text" class="form-control form-control-default" :placeholder="$t('association.RVORelationnumber')">
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('association.Phone_number') }} / {{ $t('association.Mobile_number') }}</label>
                <input v-model="localFormData.phoneNumber" type="text" class="form-control form-control-default" :placeholder="$t('association.Phone_number')">
            </div>
          </div>
      </div>      
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto mb-0 js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { computed, reactive, watch } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: "AssociationInfo",
  props: {
    formData: Object,    
    nextStep: Function
  },
  setup(props, { emit }) {
    const { t } = useI18n()

    const localFormData = reactive({ ...props.formData })

    const rules = computed(() => ({      
      name: { required: helpers.withMessage(t('common.Required'), required) },
      abbreviation: { required: helpers.withMessage(t('common.Required'), required) }
    }))
    
    const v$ = useVuelidate(rules, localFormData)
        
    watch(localFormData, () => {
      emit('update:formData', localFormData)
    }, { deep: true })

    const validateAndNextStep = async () => {
      v$.value.$touch() // Mark all fields as touched
      if (v$.value.$pending) {
        await v$.value.$validate() // Ensure validation completes
      }
      if (!v$.value.$invalid) {
        props.nextStep()
      }
    }

    return {
      localFormData,      
      v$,
      validateAndNextStep
    }
  },
  components: {      
  },
  methods: {        
  }
}
</script>